import { Record } from 'immutable';
import { SET_LOCALE } from './actions';

export const InitialState = new Record({
  locale: 'en'
});

export default (state = new InitialState(), action) => {
  switch (action.type) {
    case SET_LOCALE: {
      const { locale } = action;
      return state.set('locale', locale);
    }
    default: {
      return state;
    }
  }
};
